// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__31qZJ","sendOtp":"AuthorizeToLogin_sendOtp__15eP-"};